import { Row } from "@/components/Row";

export const TrackerTableHeaderContainer = ({
  Icon,
  label,
}: {
  Icon: React.ElementType;
  label: string;
}) => {
  return (
    <Row className="items-center gap-2 text-slate-700">
      <Icon className="h-4 w-4" />
      {label}
    </Row>
  );
};
